import * as Updates from "expo-updates";
import * as Device from "expo-device";

import {
  type DiagnosticItem,
  DiagnosticStatus,
} from "@/schemas/app/diagnostic";
import EnvironmentVariablesLoader from "@/utils/environment";
import { getAppVariant } from "@/utils/expo";
import { maskSensitiveValue } from "@/utils/secrets";

const fetchEnvironmentInfo = async (): Promise<DiagnosticItem[]> => {
  const variables = EnvironmentVariablesLoader.getEnvironmentVariables();

  let revenueCatApiKey;

  if (Device.osName === "iOS") {
    revenueCatApiKey = variables.revenueCat.iosPublicKey;
  } else if (Device.osName === "Android") {
    revenueCatApiKey = variables.revenueCat.androidPublicKey;
  } else {
    revenueCatApiKey = "Unknown";
  }

  return [
    {
      id: "node_env",
      name: "Node Env",
      value: process.env.NODE_ENV,
      status: process.env.NODE_ENV
        ? DiagnosticStatus.OK
        : DiagnosticStatus.ERROR,
    },
    {
      id: "environment",
      name: "Environment",
      value: variables.environment,
      status: variables.environment
        ? DiagnosticStatus.OK
        : DiagnosticStatus.ERROR,
    },
    {
      id: "channel",
      name: "Update Channel",
      value: Updates.channel || "Unknown",
      status: Updates.channel ? DiagnosticStatus.OK : DiagnosticStatus.ERROR,
    },
    {
      id: "app_variant",
      name: "App Variant",
      value: getAppVariant(),
      status: getAppVariant() ? DiagnosticStatus.OK : DiagnosticStatus.ERROR,
    },
    {
      id: "apiServer",
      name: "Api Server",
      value: variables.baseApiUrl,
      status: variables.baseApiUrl
        ? DiagnosticStatus.OK
        : DiagnosticStatus.ERROR,
    },
    {
      id: "clientId",
      name: "Client ID",
      value: variables.apiClientId
        ? maskSensitiveValue(variables.apiClientId)
        : "Unknown",
      status: variables.apiClientId
        ? DiagnosticStatus.OK
        : DiagnosticStatus.ERROR,
    },
    {
      id: "sentryDns",
      name: "Sentry DNS",
      value: variables.sentry.dns
        ? maskSensitiveValue(variables.sentry.dns)
        : "Unknown",
      status: variables.sentry ? DiagnosticStatus.OK : DiagnosticStatus.ERROR,
    },
    {
      id: "streamKey",
      name: "Stream Key",
      value: variables.stream.chatApiKey
        ? maskSensitiveValue(variables.stream.chatApiKey)
        : "Unknown",
      status: variables.stream ? DiagnosticStatus.OK : DiagnosticStatus.ERROR,
    },
    {
      id: "revenueCatApiKey",
      name: "RevenueCat ApiKey",
      value:
        revenueCatApiKey !== "Unknown"
          ? maskSensitiveValue(revenueCatApiKey)
          : "Unknown",
      status:
        revenueCatApiKey !== "Unknown"
          ? DiagnosticStatus.OK
          : DiagnosticStatus.ERROR,
    },
  ];
};

export default fetchEnvironmentInfo;
